import { SxProps, Theme } from "@mui/material";
import { getStyleLogin } from "../../utils/functions";

const LOGIN_STYLES = getStyleLogin();

export const sharedLoginTextFieldSx: SxProps<Theme> = {
    marginBottom: 0,
    '& .MuiOutlinedInput-root': {
        minHeight: 56,
        '& .MuiOutlinedInput-input': {
            paddingTop: '16.5px',
            paddingBottom: '16.5px'
        },
        '& .MuiOutlinedInput-input.MuiInputBase-inputAdornedEnd': {
            paddingTop: '16.5px',
            paddingBottom: '16.5px'
        },
        '&:hover fieldset': {
            borderColor: LOGIN_STYLES.hoverColor,
        },
        '&.Mui-focused fieldset': {
            borderColor: LOGIN_STYLES.borderColor,
        },
    },
    '& .MuiInputLabel-root': {
        color: '#476773',
        fontSize: '1rem',
        fontWeight: 400,
        transition: 'all 0.2s ease',
        '&.Mui-focused': {
            color: LOGIN_STYLES.labelColor,
        },
    },
    '& .MuiInputLabel-root.MuiInputLabel-outlined': {
        transform: 'translate(14px, 20px) scale(1)'
    },
    '& .MuiInputLabel-root.MuiInputLabel-outlined.MuiInputLabel-shrink': {
        transform: 'translate(14px, -9px) scale(0.75)'
    },
    '& .MuiInputLabel-asterisk': {
        color: '#F44336',
        fontSize: '1rem'
    }
};